export default "/images/f86a119bf10c0d9fda587e417ca8c880.avif";